import React, { Component } from "react";
import { DatePicker, Form, Input, Select } from "antd";
import moment from "moment";

export const renderField = ({
    input,
    label,
    type,
    placeholder,
    meta: { touched, error, warning }
}) => (
    <Form.Item
        validateStatus={touched && error ? "error" : ""}
        help={(touched && error) || ""}
    >
        <Input
            {...input}
            placeholder={placeholder}
            type={type} />
    </Form.Item>
);

export const renderDatePicker = ({
    input,
    label,
    type,
    meta: { touched, error, warning }
}) => (
    <Form.Item
        validateStatus={touched && error ? "error" : ""}
        help={(touched && error) || ""}
    >
        <DatePicker
            disabledDate={current => {
                return current && current > moment().subtract(18, "years");
            }}
            {...input}
            format="LL"
            placeholder="Birthday"
            showToday={false}
        />
    </Form.Item>
);

export class renderSelectField extends Component {

    render() {
        const {
            input, placeholder,
            meta: { touched, error },
            options, multi = false, onSearch } = this.props;

        const optionsComponent = options.map((record, i) => <Select.Option key={i} value={record.value}>{record.text}</Select.Option>);

        return (
            <div>
                <Select
                    {...this.props}
                    {...input}
                    value={input.value ? input.value : undefined}
                    onChange={input.onChange}
                    placeholder={placeholder}
                    required
                    style={{ marginTop: "4px" }}
                    onSearch={onSearch}
                    showSearch={!!(multi || onSearch)}
                    showArrow={!!onSearch}
                    mode={multi ? 'multiple' : 'default'}
                >
                    {optionsComponent}
                </Select>
                {touched && error ? (
                    <div className="input-error-label">{error}</div>
                ) : (
                    <div className="input-error-label">&nbsp;</div>
                )}
            </div>
        )
    }

}





// WEBPACK FOOTER //
// ./src/utils/forms.js